import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import jquery from "../../icons/mob-app/jquery.png"
import html from "../../icons/mob-app/html_1051277 1.png"
import Front_end_devlopment from "./Front_end_development"
import SEO from '../../components/SEO';
const Item = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    borderRadius: '10px',
    border: ' 1.5px solid #C4D2EE',
    height: '400px',
    width: '350px',
    backgroundColor: '#fff',
    padding: theme.spacing(1),
    //   textAlign: 'left',
    //   color: theme.palette.text.secondary,
}));

export default function RowAndColumnSpacing() {
    return (
        <>
        <SEO title="Frontend Technologies | Leeway Softech Pvt Ltd"
             description="At Leeway Softech, the team of experienced and expert frontend developers turn your ideas into reality. They create web apps that not only look great but also functions exceptionally well"
            />
        <Grid container spacing={1} className="front_page main_content">
        <Grid item xs={12} sm={12} lg={12}  className='p-[5%]'>
                <div className='text-white text-center'>
                <h1 className='text-3xl font-semibold'>Front-End Development</h1>
                <p className='text-lg font-normal'>Front-end technologies are vital subset of programming languages that perform specific functions to attain rich user experience.</p>
            </div>
        </Grid>
    </Grid> 


    <Box className="it_infra pt-[2%] w-full px-6 md:px-24">
    <h1 className='text-3xl font-semibold color-134CBC text-center mb-5'>Front-end technologies helps building reach user interfaces</h1>
            <Grid container spacing={2} columns={16} className='flex justify-center p-2.5'>
      <Grid item xs={6} >
        <Item className="big_card">
         
            <div className='text-center'>
                <img src={jquery} alt='jquery' className='inline mb-5'></img>
                <h3 >jQuery</h3>
          
              <p className='text-[#161011] text-sm'>jQuery's is designed to make it easier to navigate a document, select DOM elements, create animations, handle events, and develop Ajax applications. jQuery also provides capabilities for developers to create plug-ins on top of the JavaScript library. This enables developers to create abstractions for low-level interaction and animation, advanced effects and high-level, themeable widgets. The modular approach to the jQuery library allows the creation of powerful dynamic web pages and Web applications. AJAX stands for Asynchronous JavaScript and XML.</p>
          </div>
        </Item>
      </Grid>
  
      <Grid item xs={6} >
      <Item className="big_card">
       
            <div className='text-center'>
                <img src={html} alt='html' className='inline mb-5'></img>
                <h3 >Html</h3>
           
              <p className='text-[#161011] text-sm'>Updated with unique elements, attributes, behaviour and new possibilities that powers more superior, robust, dynamic applications and websites. It enables you to develop the next level design implementation of your websites that enhance the user engagement and give it an ascent with interactive and engaging front end development.</p>
          </div>
        </Item>
      </Grid>
  </Grid>

        </Box>

    <Front_end_devlopment/>
        </>
    );
}
